export enum UnitCategory {
	Mass = 'Mass',
}

export enum Units {
	//Mass
	kg = 'kg',
	tonne = 'tonne',
}

export type UnitDefinition = {
	category: UnitCategory;
	factor: number;
	base: Units;
};

type Threshold = {
	min?: number;
	max?: number;
};

export type ConvertOptions = {
	threshold?: Threshold;
	autoScale?: boolean;
	format?: boolean;
	rounding?: number;
};
